import React, { Component } from 'react';

import Map from './map';
import './map.styl';

class MapWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipVisible: false,
      tooltipPos: false,
      tooltipData: false,

      geocoderLatLng: []
    };

    this.updateState = this.updateState.bind(this);
    this.onGeocoderSuccess = this.onGeocoderSuccess.bind(this);
  }

  updateState(nextState) {
    this.setState(nextState);
  }

  onGeocoderSuccess(geocoderResult) {
    this.setState({ geocoderLatLng: geocoderResult.latlng });
  }

  render() {
    return (
      <div className="map-comp-wrapper">
        <Map
          updateState={this.updateState}
          geocoderLatLng={this.state.geocoderLatLng}
          config={this.props.config}
        />
      </div>
    )
  }
}

MapWrapper.defaultProps = {
  showGeocoder: true
}

export default MapWrapper;
